import { Injectable } from '@angular/core';
import { Push, PushObject, PushOptions } from '@ionic-native/push/ngx';
import { Platform } from '@ionic/angular';
import { Device } from '@ionic-native/device/ngx';
import { HttpService } from './http.service';
import { Router } from '@angular/router';

// https://github.com/aggarwalankush/ionic-push-base/blob/master/src/app/app.ts
@Injectable()
export class PushService {

    options: PushOptions = {
       android: {},
       ios: {
           alert: 'true',
           badge: true,
           sound: 'false'
       },
       windows: {},
       browser: {
           pushServiceURL: 'http://push.api.phonegap.com/v1/push'
       }
    };

    pushObject: PushObject;
    constructor(
        private platform: Platform,
        private device: Device,
        private http: HttpService,
        private push: Push,
        private router: Router
    //    private storage: LocalStorageService
    ) {
        this.platform.ready().then(() => {
            this.pushObject = this.push.init(this.options);
            this.init();
        });
    }

    /**
     * 아래 부분은 platform.ready 이후 처리되어야 하는 부분이므로
     * app.components 이하 platform.ready에서 호출한다. if(platform.is('cordova')){ fcmSvc.init(); }
     */
    private init() {
        // to check if we have permission
        this.push.hasPermission()
        .then((res: any) => {

            if (res.isEnabled) {
              console.log('We have permission to send push notifications');
            } else {
              console.log('We do not have permission to send push notifications');
            }

        });

        /**
         * notification {sound, title, message, additionalData:{coldstart:false, foreground:true}}
         */
        this.pushObject.on('notification').subscribe((notification: any) => {
            // console.log('notification', notification);
            if (notification.additionalData.foreground) {
                // 어떤 행동도 하지 않기
            } else {
                this.notificationProcess(notification.additionalData);
            }

        });

        this.pushObject.on('registration').subscribe((registration: any) => {
            // registration.registration.Type: FCM
            localStorage.setItem('fcm_token', registration.registrationId);
         });

        this.pushObject.on('error').subscribe((error: any) => console.error('Error with Push plugin', error));
        // this.set_token();

    }

    public setTokenToServer() {
        if (this.platform.is('cordova')) {
            const token = localStorage.getItem('fcm_token');
            const pushType = 'fcm';
            const tokenInfo = {push_token: token, push_type: pushType, device_id: this.device.uuid};
          // POST
            this.http.post({url: 'push/register_apps', params: tokenInfo}).then((res: any) => {
                console.log('set_token', res);
            });

        }
    }

    public removeTokenFromServer() {
        const params = {device_id: this.device.uuid, push_token: localStorage.getItem('fcm_token')};
        this.http.post({url: 'push/delete-token', params}).then((res: any) => {
            console.log('revoved token', res);
        });
    }

    // Create a channel (Android O and above). You'll need to provide the id, description and importance properties.
    public channel_create() {
        this.push.createChannel({
         id: 'testchannel1',
         description: 'My first test channel',
         // The importance property goes from 1 = Lowest, 2 = Low, 3 = Normal, 4 = High and 5 = Highest.
         importance: 3
        }).then(() => console.log('Channel created'));
    }

    // Delete a channel (Android O and above)
    public channel_delete() {
        this.push.deleteChannel('testchannel1').then(() => console.log('Channel deleted'));
    }

    // Return a list of currently configured channels
    public channel_lists() {
        this.push.listChannels().then((channels) => console.log('List of channels', channels));
    }

    private notificationProcess(payload: any) {
        switch (payload.msgType) {
            case 'pickResult':
                switch (payload.pick) {
                    case 'ladder': this.router.navigateByUrl('/games/ladder/today'); break;
                    case 'dari': this.router.navigateByUrl('/games/dari/today'); break;
                    case 'powerball': this.router.navigateByUrl('/games/powerball/today'); break;
                    case 'powerLadder': this.router.navigateByUrl('/games/powerLadder/today'); break;
                }

                break;
            case 'feed':
                this.router.navigateByUrl('/mypage/follow/follow');
                break;
            case 'feeder': // 구독하기 클릭시
                this.router.navigateByUrl('/mypage/follow/follower');
                break;
            case 'patternmatch':
                this.router.navigateByUrl('/mypage/follow/pattern');
                break;
            case 'notice': // for test
                this.router.navigateByUrl('/games/ladder/today');
                break;
            default: // 관리자단에서 보낼 경우

                break;
        }
    }
}
